import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Navbar from "../../Components/Navbar/NavBar";
import Calendar from "../../Components/Calendar/Calendar";
import Modal from "../../Components/Kanban/Modal/Modal";
import NewLeadForm from "../../Components/Kanban/LeadForm/NewLeadForm";
import { useSession } from "../../authentications/SessionContext";
import kanbanGrey from "../../Images/kanbanGrey.svg";
import kanban from "../../Images/kanban.svg";
import Orangetasklist from "../../Images/Orangetasklist.svg";
import OrangeGrey from "../../Images/OrangeGrey.svg";
import Warehousekanban from "../../Components/WarehouseComp./Warehousekanban";
import WarehouseTaskList from "../../Components/WarehouseComp./Tasklist/WarehouseTaskList";
import { useDispatch } from "react-redux";
import { warehouseActions } from "../../Redux/Reducers/WarehouseSlice";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useGetSearchParams from "../../CustomHooks/useGetSearchParams";
import filterSign from "../../Images/filterSign.svg";
import ReactSelect from "react-select";
import { Helmet } from "react-helmet-async";

const WarehouseTasklistFilterList = [
  { label: "All", value: "" },
  {
    label: "Ready",
    value: JSON.stringify(["state", "in", ["assigned", "partially_available"]]),
  },
  {
    label: "Waiting",
    value: JSON.stringify(["state", "in", ["confirmed", "waiting"]]),
  },
  { label: "Draft", value: JSON.stringify(["state", "=", "draft"]) },
  { label: "Done", value: JSON.stringify(["state", "=", "done"]) },
  {
    label: "Late",
    value: JSON.stringify([
      "state",
      "in",
      ["assigned", "waiting", "confirmed"],
    ]),
  },
  { label: "Cancelled", value: JSON.stringify(["state", "=", "cancel"]) },
];

const WarehouseTasklistSortList = [
  { label: "Default", value: "create_date" },
  { label: "Reference", value: "name" },
  { label: "Contact", value: "partner_id" },
  { label: "Schuduled Date", value: "scheduled_date" },
  { label: "Source Document", value: "origin" },
  { label: "Company", value: "company_id" },
  { label: "Status", value: "state" },
];

const ButtonContainer = styled.div`
  display: flex;
  margin-right: 9px;
  .btn-group {
    width: 210px;
    background-color: #f8f9fa !important;
  }
`;
const CustomButton = styled.button`
  &&&.custom-button {
    background-color: ${(props) => (props.active ? "#fff" : "#fff")};
    border: none;
    border-radius: 32%;
    height: 38px;
    width: 16px;
    display: flex;
    margin: 10px;
    justify-content: center;
    padding: 5px;
    cursor: pointer;

    &:hover {
      background-color: #fff;
    }
  }
`;

const WarehouseFirstSec = styled.div`
  display: flex;
  gap: 30px;
  margin-left: 12px;

  .Filter_icon_div {
    width: 50px;
    height: 47px !important;
    border-radius: 30% !important;
    background-color: #f8f9fa !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-left: 10px;
  }
  .dropdown_list_div {
    background-color: #f8f9fa;
    height: 45px;
    color: #b0b7c3;
    font-size: 14px;
    font-family: "Inter";
    border-radius: 14px;
    border: none;
    background-color: #f8f9fa;
    padding: 6px;
    border: none;
    margin-left: 10px;
  }
  .dropdown_list_div select {
    padding: 4px 14px;
    background-color: transparent;
    border: 0;
    color: #000000;
    font-size: 16px;
    width: auto;
    font-family: "Inter";
    &:focus {
      border: none;
      outline: none;
    }
  }

  option {
    font-size: 16px;
    line-height: 6;
    padding: 12px !important;
    font-family: "Inter";
    margin: 10px !important;
  }
  .sort_by {
    margin-top: 6px;
    margin-right: 10px;
    font-size: 16px;
  }
  .reactSelect {
    margin-right: 10px;
  }
  .Filter_icon_div img {
    transition: transform 0.3s ease;
  }
`;
const LeftDiv = styled.div`
  margin-top: 10px;
  margin-left: 8px;
`;

const Image = styled.img`
  &&&.custom-image {
    width: 100%;
    height: 100%;
    )};
  }
`;

const Warehouse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { changeview, selectedView, sessionInfo, searchQuery } = useSession();
  const { company_id, context } = sessionInfo;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [TasklistTypeFilter, setTasklistTypeFilter] = useState(
    WarehouseTasklistFilterList[0]
  );
  const [filterDirection, setFilterDirection] = useState("desc");

  const [TasklistSorting, setTasklistSorting] = useState(
    WarehouseTasklistSortList[0].value
  );
  const handleChangeTasklistTYpeFilter = (value, e) => {
    setTasklistTypeFilter(value);
  };

  const handleChangeTasklistSortingType = (e) => {
    setTasklistSorting(e.target.value);
  };
  const handleCreateClick = () => {
    setIsModalOpen(true);
  };

  const handleChangeTasklistSorting = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const getPickingType = () => {
    if (selectedView === "kanbanView") {
      return {};
    }
    return location.state || {};
  };
  const refetchData = ({ offset = 0 }) => {
    dispatch(
      warehouseActions.fetchWarehouseData({
        selectedView,
        model:
          selectedView === "kanbanView"
            ? "stock.picking.type"
            : "stock.picking",
        company_id,
        context,
        selectedView,
        pagination: {
          limit: PAGINATION_DEFAULT_LIMIT,
          offset,
        },
        search: {
          query: searchQuery || "",
          type: TasklistTypeFilter?.value || "",
          ...getPickingType(),
          // filter:TasklistTypeFilter?.value || ""
        },
        sort: {
          type: TasklistSorting || "",
          dir: filterDirection,
        },
      })
    );
  };
  useEffect(() => {
    refetchData({});
  }, [
    selectedView,
    searchQuery,
    TasklistTypeFilter,
    TasklistSorting,
    filterDirection,
  ]);

  return (
    <div>
      <Helmet>
        <title>Warehouse | iON Merchant Portal</title>
        <meta name="Warehouse" />
      </Helmet>

      {/* {isModalOpen && ( */}
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <NewLeadForm />
      </Modal>
      {/* )} */}

      {selectedView !== "kanbanView" && (
        <div className="d-flex justify-content-between">
          <LeftDiv className="">
            <WarehouseFirstSec>
              <div className="reactSelect">
                <ReactSelect
                  value={TasklistTypeFilter}
                  options={WarehouseTasklistFilterList}
                  name="type"
                  onChange={handleChangeTasklistTYpeFilter}
                />
              </div>

              <div className="Filter_icon_div">
                <img
                  src={filterSign}
                  alt="filter"
                  style={{
                    transform: `rotate(${
                      filterDirection === "asc" ? "180" : "0"
                    }deg)`,
                  }}
                  onClick={handleChangeTasklistSorting}
                />
              </div>
              <div className="dropdown_list_div d-flex">
                <div className="sort_by">Sort by:</div>

                <select
                  className="custom-select"
                  onChange={handleChangeTasklistSortingType}
                  value={TasklistSorting}
                  name="type"
                >
                  {WarehouseTasklistSortList.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                      style={{ padding: "15px 0" }}
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </WarehouseFirstSec>
          </LeftDiv>

          <ButtonContainer>
            <div className="btn-group" role="group" aria-label="Basic example">
              <CustomButton
                type="button"
                className={`btn btn-custom custom-button ${
                  selectedView === "kanbanView" ? "active" : ""
                }`}
                active={selectedView === "kanbanView" ? "true" : "false"} // Pass as string
                onClick={() => {
                  changeview("kanbanView");
                  navigate("/homepage/warehouse");
                }}
              >
                <div>
                  <Image
                    className="custom-image"
                    src={selectedView === "kanbanView" ? kanban : kanbanGrey}
                    alt="Profile Image"
                  />
                </div>
              </CustomButton>
              <CustomButton
                type="button"
                className={`btn btn-custom custom-button ${
                  selectedView === "taskList" ? "active" : ""
                }`}
                active={selectedView === "taskList" ? "true" : "false"}
                onClick={() => changeview("taskList")}
              >
                <div>
                  <Image
                    className="custom-image"
                    src={
                      selectedView === "taskList" ? Orangetasklist : OrangeGrey
                    }
                  />
                </div>
              </CustomButton>
              <CustomButton
                type="button"
                className={`btn btn-custom custom-button ${
                  selectedView === "timeoff" ? "active" : ""
                }`}
                active={selectedView === "timeoff" ? "true" : "false"}
                onClick={() => changeview("timeoff")}
              >
                <div>
                  <Image
                    className="custom-image"
                    src={
                      selectedView === "timeoff"
                        ? require("../../Images/Calender.png")
                        : require("../../Images/CalendarG.png")
                    }
                    alt="Profile Image"
                  />
                </div>
              </CustomButton>
            </div>
          </ButtonContainer>
        </div>
      )}
      {selectedView === "kanbanView" ? (
        <Warehousekanban />
      ) : selectedView === "timeoff" ? (
        <Calendar />
      ) : (
        <WarehouseTaskList refetchData={refetchData} />
      )}
    </div>
  );
};

export default Warehouse;
